import { createRef, Component } from "react";
import ReactDOMServer from "react-dom/server";

import { Webix } from "common/components/webix/react/webix";
import { getters } from "common/components/getters/getters";
import { CheckBox } from "common/components/checkbox";
import { Anchor, PrimaryButton, CancelButton } from "common/components/buttons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/pro-solid-svg-icons";
import { faCheckSquare } from "@fortawesome/pro-light-svg-icons";

export class TableConfig extends Component {
    constructor(props) {
        super(props);
        this.list_ref = createRef();
        this.state = {
            config: props.config,
            selectAll: false
        };
        this.ui = {
            view: "list",
            minHeight: 300,
            minWidth: 500,
            autowidth: true,
            drag: true,
            select: false,
            scrollY: false,
            template: (obj) => ReactDOMServer.renderToStaticMarkup(
                <>
                    <span className="grip-icon">
                        <FontAwesomeIcon icon={faGripVertical}/>
                    </span>
                    <CheckBox
                        className="config-list-checkbox"
                        label={obj.header}
                        value={obj.collapsed_visible}
                        onChange={() => {}}
                        name={toString(obj.id)}
                    />
                </>
            ),
            adjust: true,
            on: {
                onAfterDrop: this.handleDrop,
                onItemClick: this.toggleVisibility
            }
        };
    }

    componentDidMount() {
        const { data } = this.props.config;
        this.setState({
            config: {
                ...this.props.config,
                data: data.map((item, index) => ({ weight: index, ...item }))
            }
        });
    }

    getSnapshotBeforeUpdate() {
        const node = this.list_ref.current.getWebixElement().getNode();
        return {
            listScrollTop: node.scrollTop
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const list = this.list_ref.current.getWebixElement();
        list.refresh();
        if (snapshot !== null) {
            list.getNode().scrollTop = snapshot.listScrollTop;
        }
    }

    componentWillUnmount() {
        this.list_ref = null;
    }

    toggleVisibility = (id, e, node) => {
        const getter = this.list_ref.current.ui.getItem(id);
        this.setState(
            (prevState) => {
                const data = prevState.config.data
                    .map((item) => (item.getter_ref === getter._id ? { ...item, collapsed_visible: !item.collapsed_visible } : { ...item }));
                return { config: { ...prevState.config, data } };
            }
        );
    };

    setAllVisibility = (e) => {
        this.setState(
            (prevState) => ({
                selectAll: e.target.value,
                config: {
                    ...prevState.config,
                    data: prevState.config.data.map((item) => ({ ...item, collapsed_visible: e.target.value }))
                }
            })
        );
    };

    handleDrop = (context, event) => {
        this.setState((prevState) => {
            const { _id } = this.list_ref.current.ui.getItem(context.start);
            const current_config = [...prevState.config.data];
            const target_pos = context.index;
            const source = current_config.find((obj) => obj.getter_ref === _id);
            if (target_pos < source.weight) {
                current_config.splice(source.weight, 1, null);
            } else {
                current_config.splice(source.weight, 1);
            }
            current_config.splice(target_pos, 0, source);
            const data = current_config
                .filter((item) => item !== null)
                .map((item, index) => ({ ...item, weight: index }));
            return { config: { ...prevState.config, data } };
        });
    };

    handleSave = () => {
        const config = { ...this.state.config };
        // strip 'weight' fields
        config.data = config.data.map(({ getter_ref, tooltip, collapsed_visible, plain }) => ({
            getter_ref, tooltip, collapsed_visible, plain
        }));
        this.props.saveConfig(config);
    };

    handleReset = () => {
        this.setState((prevState) => ({
            config: {
                ...this.props.getPazienConfig(),
                _id: prevState.config._id,
                level: prevState.config.level
            }
        }));
    };

    renderActions = () => (
        <div className="actions">
            <div className="group">
                <Anchor href onClick={this.handleReset}>Reset to Pazien defaults</Anchor>
            </div>
            <div className="group">
                <CancelButton onClick={this.props.close}>Cancel</CancelButton>
                <PrimaryButton onClick={this.handleSave}>Save</PrimaryButton>
            </div>
        </div>
    );

    render() {
        const columns_list = this.state.config.data
            .reduce((memo, item, index) => [...memo, { ...getters.findById(item.getter_ref), weight: index, ...item }], [])
            .sort((a, b) => (a.weight > b.weight ? 1 : -1))
            .map((item) => ({ ...item, header: item.name }));

        return (
            <div className="configurable-table-config table-config">
                <HintSection />
                <div className="list-header">
                    <CheckBox label="Select all" name="selectAll" onChange={this.setAllVisibility} value={this.state.selectAll} />
                </div>
                <Webix className="config-columns" ui={this.ui} data={columns_list} ref={this.list_ref} />
                {this.renderActions()}
            </div>
        );
    }
}

function HintSection() {
    return (
        <div className="hint-section">
            <div className="hint">
                <div className="title">
                    Arrange columns
                </div>
                <div className="message">
                    Drag <span className="grip-icon"><FontAwesomeIcon icon={faGripVertical}/></span> the fields to arrange them in your preferred display order.
                </div>
            </div>
            <div className="hint">
                <div className="title">
                    Show / hide columns
                </div>
                <div className="message">
                    Choose <span><FontAwesomeIcon icon={faCheckSquare}/></span> which columns you want to show or hide while in collapsed view.
                </div>
            </div>
        </div>
    );
}
